import './SecondaryRegistration.css'
import React, { Component } from 'react'
import axios from 'axios'
import { PORT } from '../../config'
import { notify } from 'react-notify-toast'
import { Link } from 'react-router-dom'
import '../User2/UserProfile.css'

import 'react-phone-number-input/style.css'
import PhoneInput, { isValidPhoneNumber }  from 'react-phone-number-input'

import SignupContainer from '../Signup-Login/SignupContainer'
import FormField from '../../Components/FormField/FormField'
import FormDropdown from '../../Components/FormField/FormDropdown'
import ConfirmButton from '../../Components/Buttons/ConfirmButton'
import CancelButton from '../../Components/Buttons/CancelButton'
import HoverIcon from '../../Components/FormField/HoverIcon-nova'
import Modal from '../../Components/Modal/Modal'
import { connect } from 'react-redux'
import { updateToRoot } from '../../redux/homePage/homePage.actions'
import { API } from '../../API'

const URL = PORT
const isNumeric = (value) => {
  return /^[0-9]*$/.test(value)
}
class SecondaryRegistration extends Component {
  constructor(props) {
    super(props)
    // if the user not come from the verification email
    // redirect to home
    // else if the user has first_name means they register their details already
    // redirect to home
    // if(!props.location.state){
    //   props.history.push({pathname:'/'})
    // }else if(props.location.state.first_name){
    //   props.history.push({pathname:'/'})
    // }
    // console.log(props.location.state)

    this.state = {
      email: props.location.state ? props.location.state.email : '',
      first_name: props.location?.state?.first_name || '',
      last_name: props.location?.state?.last_name || '',
      contact_no: '',
      secret_answer1: '',
      secret_answer2: '',
      contact_number_verified: props.location.state
        // ? props.location.state.contact_number_verified
        ? true
        : false,
      // contact_number_verified: false,
      showPopup: false,
      isMobileValid: false,
      showConfirmNumber: false,
      icon: 'information-outline',
      user_id: '',
      hovered_text:
        'We will use your mobile number to contact you when shifts arise that match your availability',
      showElicosWarningModal: true,
    }
  }

  

  hanldeLastName = (event) => {
    event.preventDefault()
    this.setState({
      last_name: event.target.value,
    })
  }

  hanldeFirstName = (event) => {
    event.preventDefault()
    this.setState({
      first_name: event.target.value,
    })
  }

  hanldeContactNo = (event) => {
    event.preventDefault()
    if (event.target.value.length === 8 && !isNaN(event.target.value.length)) {
      this.setState({
        contact_no: event.target.value,
        isMobileValid: true,
      })
    } else {
      this.setState({
        contact_no: event.target.value,
        isMobileValid: false,
      })
    }
}

  handleNumberChange = (event) => {
    this.setState({value:event})
    this.setState({contact_no: event})
    }

  handleClickRgister = (event) => {
    event.preventDefault()
    const props = this.props
    // if (this.state.contact_number_verified) {
      // if (true) {
      const user_id =
        this.state.first_name[0].toUpperCase() +
        this.state.first_name.slice(1) +
        '_' +
        this.state.last_name[0].toUpperCase()
      if (
        /^[aA-zZ-]+$/g.test(this.state.first_name) &&
        /^[a-zA-Z\s]*$/g.test(this.state.last_name)
      ) {
        API.setSecondRegister({
          email: this.state.email,
          first_name: this.state.first_name,
          last_name: this.state.last_name,
          contact_no: this.state.contact_no,
          secret_question1: document.querySelector('#secret_question1').value,
          secret_question2: document.querySelector('#secret_question2').value,
          secret_answer1: this.state.secret_answer1,
          secret_answer2: this.state.secret_answer2,
          user_id: user_id,
        })
          .then((res) => {
            // window.localStorage.setItem("token", res.data.token)
            const user = res.data.user
            this.props.updateToRoot(user)
            window.localStorage.setItem('token', res.data.token)
            window.localStorage.setItem('userID', res.data.user._id)
            // window.localStorage.setItem("user", JSON.stringify(user))
            // window.localStorage.setItem("shared_teacher", JSON.stringify(user))
            // const path = {
            //   pathname: `/dashboard`,
            //   // state: res.data,
            // }
            window.localStorage.setItem('firstTime', 'true')
            props.history.push('/Dashboard', { firstTime: true })
          })
          .catch((err) => {
            console.log(err)
            if (err.response.status === 422) {
              notify.show(err.response.data.msg)
            }
          })
      } else {
        notify.show('Please use only letters in first name or last name')
      }
    // } else {
    //   notify.show(
    //     'Please verify your mobile number to proceed. We will use your number to contact you when shifts arrive that match your availability.',
    //     'custom',
    //     5000,
    //     { background: '#050505', text: '#FFFFFF' },
    //   )
    // }
  }

  hanldeSecretAnswer1 = (event) => {
    event.preventDefault()
    this.setState({
      secret_answer1: event.target.value,
    })
  }

  hanldeSecretAnswer2 = (event) => {
    event.preventDefault()
    this.setState({
      secret_answer2: event.target.value,
    })
  }

  handleShowPopUp = () => {
    this.setState({
      showPopup: !this.state.showPopup,
    })
  }

  handleConfirmNumber = () => {
    const mobile = document.querySelector('#verifycode').value
    if (mobile) {
        if (isValidPhoneNumber(mobile)) {
            this.setState({
                showConfirmNumber: true,
                isMobileValid: false,
              })
        } else {
            notify.show('Invalid phone number')
        }
    } else {
        notify.show('Phone number required')
    }
  }

  handleChangeNumber = () => {
    this.setState({
      showConfirmNumber: false,
      isMobileValid: false,
      contact_number_verified: false,
    })
  }

  handleCancelCode = () => {
    this.setState({
      showPopup: false,
    })
    this.handleChangeNumber()
  }

  verify_contact_number = () => {
    this.setState({ contact_number_verified: true })
    this.handleIcon()
  }

  handleIcon = () => {
    this.setState({
      icon: 'checkbox-marked-circle check-green',
      hovered_text: 'Verified',
    })
  }

  handleRequestOTP = (event) => {
    event.preventDefault()
    const mobile = document.querySelector('#verifycode').value
    const email = document.querySelector('#email').value
    this.setState({
      isMobileValid: false,
      showConfirmNumber: false,
    })
    const popup = this.handleShowPopUp

    API.requestOTP({
      params: {
        email: email,
        mobile: mobile.substring(1),
      }
    })
      .then(function (response) {
        popup()
        // console.log("res", response.data)
        window.auth_user_id = response.data.auth_user_id
      })
      .catch(function (error) {
        console.log('error', error)
      })
  }

  togglePopup = () => {
    const codes = document.querySelector('#verifycode1').value
    const popup = this.handleShowPopUp
    const email = document.querySelector('#email').value
    const verify_contact_number = this.verify_contact_number
    if (isNumeric(codes)) {
      API.verifyOTP({
        params: {
          id: window.auth_user_id,
          token: codes,
          email: email,
        },
      })
        .then(function (response) {
          popup()
          verify_contact_number()
          // console.log(response)
          notify.show('Mobile number verified')
        })
        .catch(function (error) {
          console.log(error)
          notify.show('Please enter the exact code sent to your phone')
        })
    } else {
      console.log('Please enter numbers only')
      notify.show('Please enter numbers only')
    }
  }

  //Auto filling the form
  //A a function will pe added to submit the post the user Data extracted from google

  render() {
    //add a debugger so the application will automatically stop when executed
    return (
      <SignupContainer
        heading="Registration Details"
        onSubmit={this.handleClickRgister}
      >
        <FormField
          label="Email"
          icon="email"
          id="email"
          name="email"
          placeholder={this.state.email}
          disabled={true}
          defaultValue={this.state.email}
          autoFocus
          required
        />
        <FormField
          label="First Name"
          id="firstname"
          name="firstname"
          placeholder="First Name"
          value={this.state.first_name}
          onChange={this.hanldeFirstName}
          autoFocus
          required
        />
        <FormField
          label="Last Name"
          id="lastname"
          name="lastname"
          placeholder="Last Name"
          value={this.state.last_name}
          onChange={this.hanldeLastName}
          required
        />
        <PhoneInput
          label="Mobile Number"
          inputComponent={FormField}
          icon="phone"
          id="verifycode"
          name="mobile"
          placeholder="Enter phone number"
          value={''}
          onChange={this.handleNumberChange}
          defaultCountry="AU"
          international
          autoFocus
          required
          // disabled={this.state.contact_number_verified}
          header={
            this.state.contact_number_verified ? (
              <>
                <span>{'    '}</span>
                <HoverIcon
                  icon="check circle"
                  place="right"
                  text="Verified"
                  color="green"
                  type="success"
                />
              </>
            ) : (
              <>
                <span>{'    '}</span>
                <HoverIcon
                  icon="question circle outline"
                  place="right"
                  text="We will use your mobile number to contact you when shifts arise that match your availability"
                />
              </>
            )
          }
          // sideButton={{
          //   label: this.state.contact_number_verified ? 'Change' : 'Verify',
          //   onClick: this.state.contact_number_verified
          //     ? this.handleChangeNumber
          //     : this.handleConfirmNumber,
          // }}
        >
          <Modal
            className="confirm-number-modal"
            header="MOBILE VERIFICATION"
            show={this.state.showConfirmNumber}
            onClose={() => this.setState({ showConfirmNumber: false })}
          >
            <h5 className="contact_numberConfirmation1">
              Is {this.state.contact_no} your number?
            </h5>
            <div className="row m-0">
              <div className="col-md-6" id="mobileVerify">
                <CancelButton type="button" onClick={this.handleChangeNumber}>
                  No and Change
                </CancelButton>
              </div>
              <div className="col-md-6 padding-for-mobile" id="mobileVerify">
                <ConfirmButton type="button" onClick={this.handleRequestOTP}>
                  Yes and Proceed
                </ConfirmButton>
              </div>
            </div>
          </Modal>

          <Modal
            className="confirm-number-modal"
            header="Confirmation Code"
            show={this.state.showPopup}
            onClose={this.handleCancelCode}
          >
            <div className="row m-0 d-flex justify-content-center">
              <FormField
                type="number"
                id="verifycode1"
                name="verifycode"
                className="col-md-6 mx-5"
                placeholder="Enter the code sent to your phone"
                autoFocus
              />
              <div className="col-md-6">
                <CancelButton type="button" onClick={this.handleCancelCode}>
                  Cancel
                </CancelButton>
              </div>
              <div className="col-md-6 padding-for-mobile">
                <ConfirmButton type="button" onClick={this.togglePopup}>
                  Verify
                </ConfirmButton>
              </div>
            </div>
          </Modal>
        </PhoneInput>
        <FormDropdown
          label="Choose your first secret question"
          icon="account-check"
          id="secret_question1"
        >
          <option defaultValue="Mother’s maiden name">
            What is your mother’s maiden name?
          </option>
          <option value="First pet’s name">
            What was your first pet’s name?
          </option>
          <option value="Favourite movie">What is your favourite movie?</option>
        </FormDropdown>
        <FormField
          label="Answer"
          id="secret-answer-1"
          name="secret-answer-1"
          placeholder="Enter Your Answer"
          value={this.state.secret_answer1}
          onChange={this.hanldeSecretAnswer1}
          required
        />
        <FormDropdown
          label="Choose your second secret question"
          icon="account-check"
          id="secret_question2"
        >
          <option defaultValue="Best friend’s name">
            What is your best friend’s name?
          </option>
          <option value="Favourite class type or level to teach">
            What is your favourite class type or level to teach?
          </option>
          <option value="First street">
            What was the first street where you lived?
          </option>
        </FormDropdown>
        <FormField
          label="Answer"
          id="secret-answer-2"
          name="secret-answer-2"
          placeholder="Enter Your Answer"
          value={this.state.secret_answer2}
          onChange={this.hanldeSecretAnswer2}
          required
          className="mb-5"
        />
        <ConfirmButton type="submit">Submit</ConfirmButton>

        {this?.props?.location?.state?.is_elt && this.state.showElicosWarningModal &&
        <Modal
        show={true}
        header="There's no work for ELICOS teacher"
        className="export-booking-modal"
        onClose={() => {
          this.setState({
            showElicosWarningModal: false
          });
        }}
        >
          <div className="row d-flex flex-column align-items-center text-center">
            <p>
            ReadyTeacher offers no guarantee of work. ELICOS opportunities are extremely low in Australia at this time. You are welcome to set up your Profile for future alerts or apply to our offshore jobs in Asia.
            </p>

            <div className="mt-5 col-md-8 d-flex justify-content-center">
              <button className="btn btn-primary" onClick={() => {
                this.setState({
                  showElicosWarningModal: false
                });
              }}>
                Got it
              </button>
            </div>
          </div>
        </Modal>}
      </SignupContainer>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) => dispatch(updateToRoot(user)),
})

export default connect(null, mapDispatchToProps)(SecondaryRegistration)
